import type { ContentStoryblok } from "@/types/storyblok-blok-types";

import UI from "./UI";

export const Form = ({ blok }: { blok: ContentStoryblok }) => {
  return <UI blok={blok} />;
};

export default Form;
